/* eslint-disable no-param-reassign */
import m from "mithril";
import moment from "moment";
import header from "../../components/header";
import toolbar from "../../components/toolbar"
import sidebar from "../../components/sidebar"
import table_data from "../../components/table_data"
import graph from "./components/graph";
import multiSelect from "../../components/bootstrap-select";
import companyBannner from "../../components/companyBannner";
import { runQuery, headers } from "../../utils/fetchData";
import timePicker from "../../components/timePicker";
import htmlEditor from "../../components/htmlEditor";
import config from "../../config";
import stats from "./components/stats";
import map from "./components/google-maps";
import tmpMap from "./components/tmpMap";
import tutorials from "./components/tutorials";
import commonQuestions from "./components/commonQuestions";
import dataMap from "../../utils/data";

import { t } from '../../translation-files/translator'
import footer from "../../components/footer";



function getNumberWithOrdinal(i) {
  const j = i % 10;

  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return "rd";
  }
  return `${i}th`;
}

export default {
  async oninit({ state, attrs }) {
    Object.assign(state, {
      selectedTeams: [],
      selectedUsers: [],
      selectedProjects: [],
      teams: [],
      users: [],
      projects: [],
      projectsT: true,
      teamsT: false,
      usersT: false,
      fetching: false,
      selectedTime: {
        end: moment(new Date()),
        start: moment(new Date())
          .subtract(6, "day")
          .startOf("day")
      },
      data: [],
      labels: [],
      stats: {},
      gpsData: []
    });

    state.fetchResults = async clientId => {
      const { start, end } = state.selectedTime;

      state.fetching = true;
      m.redraw();

      try {
        const results = await m.request({
          method: "POST",
          headers: headers(),
          url: `${config[window.env].apiUrl}/submision/breakDayDown/${new Date(
            start
          ).toISOString()}/${new Date(end).toISOString()}`,
          data: Object.assign(
            {
              client: clientId
            },
            state.teamsT === true
              ? { teamId: { $in: state.selectedTeams } }
              : {},
            state.projectsT === true
              ? { projectId: { $in: state.selectedProjects } }
              : {},
            state.usersT === true
              ? { userId: { $in: state.selectedUsers } }
              : {}
          )
        });

        Object.assign(state, {
          fetching: false,
          data: [],
          labels: []
        });
        m.redraw();

        const labels = Object.values(results)
          .reverse()
          .map(
            ({ start }) =>
              `${getNumberWithOrdinal(moment(start).format("DD"))}-${moment(
                start
              ).format("MM")}`
          );

        const data = Object.values(results)
          .reverse()
          .map(({ count }) => count);

        const gpsData = Object.values(results)
          .reverse()
          .map(({ data }) => data);

        Object.assign(state, {
          data,
          labels,
          gpsData
        });

        m.redraw();
      } catch (err) {
        Object.assign(state, {
          fetching: false
        });
        m.redraw();
      }
    };

    state.resetSelections = () => {
      Object.assign(state, {
        selectedTeams: [],
        selectedUsers: [],
        selectedProjects: [],
        teams: [],
        users: [],
        projects: [],
        projectsT: true,
        teamsT: false,
        usersT: false,
        selectedTime: {
          end: moment(new Date()),
          start: moment(new Date())
            .subtract(6, "day")
            .startOf("day")
        },
        fetching: false,
        data: [],
        labels: []
      });

      m.redraw();
    };

    const {
      users,
      id: clientId,
      stats,
      teams,
      projects
    } = await dataMap.getClientData();

    Object.assign(state, {
      projects,
      teams,
      users,
      stats,
      clientId,
      selectedTeams: [...teams.map(p => p.id)],
      selectedUsers: [...users.map(p => p.id)],
      selectedProjects: [...projects.map(p => p.id)]
    });

    state.fetchResults(clientId);
    m.redraw();
  },
  // disable due to failures on some browsers
  oncreate() {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const accType = urlParams.get('u');
    //   if (accType === 'new')
    //     introJs().start();
    new Dropzone("#kt_dropzonejs_example_1", {
      url: "https://keenthemes.com/scripts/void.php", // Set the url for your upload script location
      paramName: "file", // The name that will be used to transfer the file
      maxFiles: 10,
      maxFilesize: 10, // MB
      addRemoveLinks: true,
      accept: function (file, done) {
        if (file.name == "wow.jpg") {
          done("Naha, you don't.");
        } else {
          done();
        }
      }
    });
  },
  view({ state, attrs }) {
    console.log({ t: t() })
    return [
      // <!--begin::Header-->
      m(header, {
        logos: {
                  dark: "assets/media/logos/rubis-logo-white.svg",
          light: "assets/media/logos/rubis-logo-white.png"
        },
        links: [{
          label: t().home_acc_info.navbar.reports,
          route: "/reports",
        }, {
          label: t().home_acc_info.navbar.user_management,
          route: "/userManagement"
        }, {
          label: t().home_acc_info.navbar.support,
          route: ""
        }, {
          label: t().home_acc_info.navbar.notifications,
          route: ""
        }, {
          label: t().home_acc_info.navbar.trends,
          route: ""
        }]
      }),
      // <!--end::Header-->

      // <!--begin::Wrapper-->
      m("div", { "class": "app-wrapper flex-column flex-row-fluid", "id": "kt_app_wrapper" }, [
        // <!--begin::Main-->
        m("div", { "class": "app-main flex-column flex-row-fluid", "id": "kt_app_main" }, [
          // <!--begin::Content wrapper-->
          m("div", { "class": "d-flex flex-column flex-column-fluid" }, [
            m("div", { "class": "separator my-10" }),
            // <!--begin::Content-->
            m("div", { "class": "app-container container-xxl", "id": "kt_app_content_container" }, [
              // <!--begin::Inbox App - Messages -->
              m("div", { "class": "d-flex flex-column flex-lg-row" }, [
                // <!--begin::Sidebar-->
                m(sidebar, {
                  sideBarItems: [{
                    label: t().card_to_card.sidebar_labels.top_up,
                    icon: "bi bi-book",
                    route: "/funds"
                  },
                  {
                    label: t().card_to_card.sidebar_labels.card_to_card,
                    icon: "bi bi-book",
                    route: "/cardToCard",
                    routesToActivate: ["/cardToCard/single", "/cardToCard/bulk"]
                  }]
                }),
                // <!--end::Sidebar-->
                // <!--begin::Content-->
                m("div", {
                  "class": "app-content", "id": "kt_app_content", style: {
                    "flex-grow": 1,
                    "flex-basis": "auto",
                  }
                },
                  m("div", { "class": "app-container container-xxl", "id": "kt_app_content_container" },
                    [
                      m("div", { "class": "col-12" }, [
                        m("div", { "class": "card mb-3" }, [
                          m("div", { "class": "card-header" }, [
                            m("h1", { "class": "card-title" }, "Card To Card Transaction"),
                          ]),

                          m("div", { "class": "card-body" }, [
                            m("div", { "class": "row" }, [
                              m("div", { "class": "col-sm-6 col-md-6 col-lg-6" }, [
                                m("div", { "class": "d-flex justify-content-start", "data-kt-customer-table-toolbar": "base", style: { "padding-top": "10px" } }, [
                                  m("div", { "class": "form-check form-check-inline" }, [
                                    m("div", { "class": "form-check form-check-custom form-check-solid" },
                                      [
                                        m("input", {
                                          "class": "form-check-input", "type": "checkbox", "value": "1", "id": "flexCheckDefault", "onchange": () => {
                                            m.route.set("/cardToCard/single")
                                            location.reload()
                                          }
                                        }),
                                        m("label", { "class": "form-check-label", "for": "flexCheckDefault" },
                                          t().single_card_to_card_complete.toolbar_actions.single,
                                        )
                                      ]
                                    ),
                                  ]),
                                  m("div", { "class": "form-check form-check-inline" }, [
                                    m("div", { "class": "form-check form-check-custom form-check-solid" },
                                      [
                                        m("input", {
                                          "class": "form-check-input",
                                          "type": "checkbox",
                                          checked: true,
                                          "value": "1",
                                          "id": "flexCheckDefault",
                                          "onchange": () => {
                                            m.route.set("/cardToCard/bulk")
                                            location.reload()
                                          }
                                        }),
                                        m("label", { "class": "form-check-label", "for": "flexCheckDefault" },
                                          t().single_card_to_card_complete.toolbar_actions.bulk,
                                        )
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]),
                              m("div", { "class": "col-sm-12 col-md-6 col-lg-6" }, [
                                m("div", { "class": "d-flex justify-content-end", "data-kt-customer-table-toolbar": "base" },
                                  m("button", { "class": "btn btn-primary", onclick: () => history.back() }, [
                                    m("i", { "class": "bi bi-arrow-left" }),
                                    "Back"
                                  ])
                                )
                              ])
                            ])
                          ])
                        ]),
                      ]),
                      m(table_data, {
                        overideHeader: true,
                        customHeader: [
                          // m("div", { "class": "card-title" }, [
                          //   m("card-label.fw-bold.text-grey-900.fs-2x.mb-3", attrs.title)
                          // ]),
                          m("form", { "class": "form", "action": "#", "method": "post", style: { "padding": "10px" } },
                            m("div", { "class": "dropzone", "id": "kt_dropzonejs_example_1" },
                              m("div", { "class": "dz-message needsclick" },
                                [
                                  m("div", { "class": "ms-4" },
                                    [
                                      m("h3", { "class": "fs-5 fw-bold text-gray-900 mb-1" },
                                        t().single_card_to_card_complete.toolbar_actions.upload_message,
                                      )
                                    ]
                                  )
                                ]
                              )
                            )
                          ),
                          m("div", { "class": "card-toolbar" },
                            [
                              m("div", { "class": "d-flex justify-content-end", "data-kt-customer-table-toolbar": "base" },
                                m("button", {
                                  "class": "btn btn-primary",
                                  onclick: () => {
                                    const a = document.createElement("a");
                                    a.href = `assets/media/illustrations/Rubis-Energie-1.jpg`;
                                    a.download = "sample_file.txt";
                                    a.click();
                                  }
                                }, [
                                  m("i", { "class": "bi bi-cloud-download" }),
                                  t().single_card_to_card_complete.toolbar_actions.download_sample,
                                ])
                              ),
                              attrs.actionItems,
                            ]
                          )
                        ],
                        dataConfigs: {
                          sourceEndpoint: "/journey_plans",
                          disabeEditing: true,
                          disableDeletion: true,
                          dataMapping: [{
                            label: t().card_to_card.cards_table_labels.from_card_column,
                            data_key: "from_card"
                          }, {
                            label: t().card_to_card.cards_table_labels.card_name_column,
                            data_key: "card_name"
                          }, {
                            label: t().card_to_card.cards_table_labels.to_card_column,
                            data_key: "to_card"
                          }, {
                            label: t().card_to_card.cards_table_labels.card_name,
                            data_key: "card_name"
                          }, {
                            label: t().card_to_card.cards_table_labels.amount,
                            data_key: "amount"
                          }],
                          dataRows: Array.from({ length: 25 }, () => ({
                            from_card: `XXXX-XXXX-XXXX-${Math.floor(Math.random() * 9000) + 1000}`,
                            card_name: `Marketing Card`,
                            amount: Math.floor(Math.random() * 1000),
                            to_card: `XXXX-XXXX-XXXX-${Math.floor(Math.random() * 9000) + 1000}`,
                            card_name: `Marketing Card`
                          }))
                        }
                      })
                    ]
                  )
                )
                // <!--end::Content-->
              ])
              // <!--end::Inbox App - Messages -->
            ])
            // <!--end::Content-->
          ]),
          m(footer)
        ])
      ])

    ];
  }
};
